<template>
  <div ref="refRoot" :class="`tes-masonry-grid tes-masonry-grid_${gridVersion}`">

    <div :class="['tes-masonry-grid__item', `tes-masonry-grid__item_${(index % 5).toString()}`]"
         v-for="(item, index) in items">

      <component :item="item" :index="index" :is="loadComponent(item)"/>

    </div>

    <EllipsisLoader :loading="loading"/>
  </div>
</template>

<script lang="ts">
import {defineAsyncComponent, defineComponent, onMounted, ref} from 'vue'
import {getLisEntityDataTid} from '../../services/fetch/list-entity'
import PostListItem, {PostListItemData, PostListItemInterface} from "../../objects/post/PostListItem"
import {PostTagData} from "../../objects/post/PostTag"
import {MediaVariantData} from "../../objects/MediaVariant";
import {ListEntityItemType} from "../../objects/list-entity/ListEntityItem";
import BannerListItem, {BannerListItemData, BannerListItemInterface} from "../../objects/banner/BannerListItem";
import {MediaData, MediaType} from "../../objects/Media"

export default defineComponent({
  name: 'MasonryListEntityGridView',
  props: {
    tid: {
      type: String,
      required: true
    },
    gridVersion: {
      type: Number,
      default: 1
    }
  },
  setup(props) {
    const refRoot = ref()
    const loading = ref(false)
    const items = ref([] as Array<PostListItemInterface|BannerListItemInterface>)

    // готовит пустые данные
    const generate = () => {
      for (let i = 0; i < 5; i++) {
        items.value.push(new PostListItem(
          {tags: [] as Array<PostTagData>, image_variants: [] as Array<MediaVariantData>} as PostListItemData
        ))
      }
    }


    // обновляет данные одного элемента
    // после загрузки навешивает обсерв на элементы
    // загружает данные
    const load = async () => {
      loading.value = true;
      let data = await getLisEntityDataTid(props.tid, {media: `masonry_${props.gridVersion}`})
      data.items.forEach((item, index) => {
        if (item.type === ListEntityItemType.banner) {
          items.value[index] = new BannerListItem({
            id: 1,
            image: {
              title: 'Весенний прогрев до -15%',
              dimensions: {width: 264, height: 414},
              url: 'https://storage.yandexcloud.net/cdn.tion.ru/images/2025/04/banner-94-264_414.jpg',
              type: MediaType.image,
              mime_type: 'image/jpeg'
            } as MediaData,
            image_variants: [
              {
                width: null,
                image: {
                  type: MediaType.image,
                  mime_type: 'image/webp',
                  dimensions: {width: 264, height: 414},
                  url: 'https://storage.yandexcloud.net/cdn.tion.ru/images/2025/04/banner-94-264_414.webp',
                }
              }
            ] as Array<MediaVariantData>,
            link: 'https://tion.ru/promo/spring-warming/?utm_source=blog&utm_medium=banner'
          } as BannerListItemData)
        } else {
          items.value[index] = new PostListItem(item.entity as PostListItemData)
        }
      })
      loading.value = false
    }

    const loadComponent = (item: object) => {
      if (item.constructor.name === PostListItem.name) {
        return defineAsyncComponent(() => import('./MasonryPostListItemView.vue'))
      }

      else if (item.constructor.name === BannerListItem.name) {
        return defineAsyncComponent(() => import('./MasonryBannerListItemView.vue'))
      }

      return null;
    }

    onMounted(() => {
      generate()
      let options = {root: null, threshold: 0}
      let observer = new IntersectionObserver((entities, observer) => {
        entities.forEach((entity) => {
          if (!entity.isIntersecting) {
            return
          }
          observer.unobserve(refRoot.value) // прекращаем следить за элементом
          load();//загружаем его
        })
      }, options)
      observer.observe(refRoot.value)
    })

    return {refRoot, loading, items, loadComponent}
  }
})
</script>

<style src="~/styles/_rating.scss"/>
<style lang="scss">
.tes-masonry-grid {
  position: relative;
  justify-content: center;

  &__item {
    width: 100%;
    position: relative;
    backface-visibility: hidden;
    text-align: left;
    overflow: hidden;
    /*display: inline-flex;*/
    cursor: pointer;

    &-picture-container {
      height: 100%;
    }

    &-picture-link {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
    }

    &-picture-wrapper {
    }

    &-picture-image {
      width: auto;
      max-width: none;
      height: 100%;
      max-height: none;
      object-fit: cover;
      transition: transform .3s ease-in-out;
    }

    &-tags {
      position: relative;
      z-index: 12;
    }

    &-tags a,
    &-tag-link {
      color: #fff;
      text-transform: uppercase;
      font-size: 14px;
      line-height: 16px;
      margin-right: 5px;
    }

    &-tag-value {
    }

    &-content {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 15px;
      overflow: hidden;
      z-index: 10;
      color: #fff;
    }

    &-head a,
    &-head {
      font-size: 18px;
      font-weight: 400;
      line-height: 21px;
      color: #fff;
    }

    &-description {
      position: absolute;
      bottom: 15px;
      width: calc(100% - 2 * 15px);

      &-value {
        font-size: 1.2em;
        line-height: 1.2em;
        margin-bottom: 10px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: 100%;
        height: 1.2em;
        white-space: nowrap;
      }
    }

    &-link_overlay {
      position: absolute;
      z-index: 11;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
    }

    &-metrics {
    }

    &-metric-count-view {
      margin-right: 20px;
    }

    &-icon-wrapper-eye {
      width: 15px;
    }

    &-icon-eye {
      width: 15px;

      g.tes-svg-icon.tes-svg-icon-eye_cyan {
        fill: #727272;
      }
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 0.15;
      transition: opacity 250ms;
    }

    &:before {
      content: '';
      display: block;
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 45%;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, #000 100%);
      opacity: 0.66;
      z-index: 1;
    }

    &:hover {
      &:after {
        opacity: 0.5;
      }

      .tes-masonry-grid__item-picture-image {
        transform: scale(1.10);
      }
    }
  }
}

.tes-masonry-grid_1.tes-masonry-grid {
  display: grid;
  grid-template-columns: repeat(4, 264px);
  grid-template-rows: [rBegin] 264px [row1] 150px [row2] 264px [rEnd];
  column-gap: 15px;
  row-gap: 15px;
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 238px);
    grid-template-rows: [rBegin] 349px [row1] 238px [row2] 238px [rEnd];
    justify-content: center;
    column-gap: 10px;
    row-gap: 10px;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: [cBegin] 1fr [line1] 1fr [cEnd];
    grid-template-rows: repeat(5, 238px);
    column-gap: 10px;
    row-gap: 10px;
  }
  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
  }
}

.tes-masonry-grid_1 {
  .tes-masonry-grid {
    &__item {

      overflow: hidden;

      &_0 {
        grid-column-start: 1;
        grid-column-end: 4;
        grid-row-start: rBegin;
        grid-row-end: row2;
      }

      &_1 {
        grid-column-start: 4;
        grid-column-end: 4;
        grid-row-start: rBegin;
        grid-row-end: row1;
      }

      &_2 {
        grid-column-start: 1;
        grid-column-end: 1;
        grid-row-start: row2;
        grid-row-end: rEnd;
      }

      &_3 {
        grid-column-start: 2;
        grid-column-end: 4;
        grid-row-start: row2;
        grid-row-end: rEnd;
      }

      &_4 {
        grid-column-start: 4;
        grid-column-end: 4;
        grid-row-start: row1;
        grid-row-end: rEnd;
      }

      &_0,
      &_3 {
        .tes-masonry-grid__item-picture-container {
          height: auto;
          width: 100%;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      &__item {

        &_0 {
          grid-column-start: 1;
          grid-column-end: 4;
          grid-row-start: rBegin;
          grid-row-end: row1;
        }

        &_1 {
          grid-column-start: 1;
          grid-column-end: 1;
          grid-row-start: row1;
          grid-row-end: row2;
        }

        &_2 {
          grid-column-start: 2;
          grid-column-end: 2;
          grid-row-start: row1;
          grid-row-end: row2;
        }

        &_3 {
          grid-column-start: 1;
          grid-column-end: 3;
          grid-row-start: row2;
          grid-row-end: rEnd;
        }

        &_4 {
          grid-column-start: 3;
          grid-column-end: 3;
          grid-row-start: row1;
          grid-row-end: rEnd;
        }
      }
    }

    @media screen and (max-width: 768px) {
      &__item {

        &_0 {
          grid-column-start: cBegin;
          grid-column-end: cEnd;
          grid-row-start: 1;
          grid-row-end: 3;
        }

        &_1 {
          grid-column-start: line1;
          grid-column-end: cEnd;
          grid-row-start: 3;
          grid-row-end: 4;
        }

        &_2 {
          grid-column-start: line1;
          grid-column-end: cEnd;
          grid-row-start: 4;
          grid-row-end: 5;
        }

        &_3 {
          grid-column-start: line1;
          grid-column-end: cEnd;
          grid-row-start: 5;
          grid-row-end: 6;
        }

        &_4 {
          grid-column-start: cBegin;
          grid-column-end: line1;
          grid-row-start: 3;
          grid-row-end: 6;
        }

        &_0,
        &_3 {
          .tes-masonry-grid__item-picture-container {
            height: 100%;
          }
        }
      }
    }

    @media screen and (max-width: 576px) {
      &__item {
        aspect-ratio: $postsAspectRatio;
        margin: 0 0 15px;

        &_0 {
        }

        &_1 {
        }

        &_2 {
        }

        &_3 {
        }

        &_4 {
        }
      }
    }
  }
}

.tes-masonry-grid_2.tes-masonry-grid {
  display: grid;
  grid-template-columns: repeat(4, 264px);
  grid-template-rows: [rBegin] 264px [row1] 150px [row2] 264px [rEnd];
  column-gap: 15px;
  row-gap: 15px;
  @media screen and (max-width: 1200px) {
    grid-template-columns: repeat(3, 238px);
    grid-template-rows: [rBegin] 238px [row1] 238px [rEnd];
    justify-content: center;
    column-gap: 10px;
    row-gap: 10px;
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: [cBegin] 1fr [line1] 1fr [cEnd];
    grid-template-rows: repeat(5, 238px);
    column-gap: 10px;
    row-gap: 10px;
  }
  @media screen and (max-width: 576px) {
    display: flex;
    flex-direction: column;
  }
}

.tes-masonry-grid_2 {
  .tes-masonry-grid {
    &__item {

      overflow: hidden;

      &_0 {
        grid-column-start: 2;
        grid-column-end: 5;
        grid-row-start: rBegin;
        grid-row-end: row2;
      }

      &_1 {
        grid-column-start: 1;
        grid-column-end: 1;
        grid-row-start: rBegin;
        grid-row-end: row1;
      }

      &_2 {
        grid-column-start: 1;
        grid-column-end: 1;
        grid-row-start: row1;
        grid-row-end: rEnd;
      }

      &_3 {
        grid-column-start: 2;
        grid-column-end: 4;
        grid-row-start: row2;
        grid-row-end: rEnd;
      }

      &_4 {
        grid-column-start: 4;
        grid-column-end: 4;
        grid-row-start: row2;
        grid-row-end: rEnd;
      }

      &_0,
      &_3 {
        .tes-masonry-grid__item-picture-container {
          height: auto;
          width: 100%;
        }
      }
    }

    @media screen and (max-width: 1200px) {

      &__item {

        &_0 {
          grid-column-start: 1;
          grid-column-end: 3;
          grid-row-start: rBegin;
          grid-row-end: row1;
        }

        &_1 {
          grid-column-start: 3;
          grid-column-end: 3;
          grid-row-start: rBegin;
          grid-row-end: row1;
        }

        &_2 {
          grid-column-start: 1;
          grid-column-end: 1;
          grid-row-start: row1;
          grid-row-end: rEnd;
        }

        &_3 {
          grid-column-start: 2;
          grid-column-end: 2;
          grid-row-start: row1;
          grid-row-end: rEnd;
        }

        &_4 {
          grid-column-start: 3;
          grid-column-end: 3;
          grid-row-start: row1;
          grid-row-end: rEnd;
        }
      }
    }

    @media screen and (max-width: 768px) {
      &__item {

        &_0 {
          grid-column-start: cBegin;
          grid-column-end: cEnd;
          grid-row-start: 1;
          grid-row-end: 3;
        }

        &_1 {
          grid-column-start: cBegin;
          grid-column-end: line1;
          grid-row-start: 3;
          grid-row-end: 4;
        }

        &_2 {
          grid-column-start: cBegin;
          grid-column-end: line1;
          grid-row-start: 4;
          grid-row-end: 5;
        }

        &_3 {
          grid-column-start: cBegin;
          grid-column-end: line1;
          grid-row-start: 5;
          grid-row-end: 6;
        }

        &_4 {
          grid-column-start: line1;
          grid-column-end: cEnd;
          grid-row-start: 3;
          grid-row-end: 6;
        }

        &_0,
        &_3 {
          .tes-masonry-grid__item-picture-container {
            height: 100%;
          }
        }
      }
    }

    @media screen and (max-width: 576px) {
      &__item {
        aspect-ratio: $postsAspectRatio;
        margin: 0 0 15px;

        &_0 {
        }

        &_1 {
        }

        &_2 {
        }

        &_3 {
        }

        &_4 {
        }
      }
    }

  }
}

.tes-masonry-grid_1 .tes-masonry-grid__item_0,
.tes-masonry-grid_2 .tes-masonry-grid__item_0 {
  .tes-masonry-grid__item-head a,
  .tes-masonry-grid__item-head {
    font-size: 30px;
    line-height: 36px;
  }
}
</style>

